export default __webpack_public_path__ + "static/media/icn_card.4e34e356.svg";